<template>
  <v-card flat>
    <v-row dense>
      <v-col cols="2">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" :disabled="isLoading" :loading="isLoading" @click="getMonthEvents()"><v-icon small>fal fa-redo</v-icon></v-btn>
          </template>
          <span>再読込</span>
        </v-tooltip>
      </v-col>
      <v-col v-if="!isLoading" cols="10" align-self="center" class="text-right pr-3">
        <v-btn-toggle mandatory  v-if="getClientId" v-model="config.type" class="transparent" @change="getMonthEvents()">
          <v-btn small :outlined="config.type !== 'all'" :depressed="config.type === 'all'" color="secondary white--text" value="all">全体</v-btn>
          <v-btn small :outlined="config.type !== 'client'" :depressed="config.type === 'client'" color="secondary white--text" value="client">個人</v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col v-else cols="10" align-self="center" class="text-right pr-3">読み込み中...</v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <v-date-picker no-title full-width
          ref="calendar"
          v-model="store.date"
          class="caption"
          locale="ja"
          backgroundColor="amber"
          prev-icon="fal fa-angle-left"
          next-icon="fal fa-angle-right"
          :day-format="date => new Date(date).getUTCDate()"
          :events="functionEvents"
          @click:date="showEvents"
          @dblclick:date="openEditor()"
          @update:picker-date="getMonthEvents"
        />
        <v-menu scrollable offset-x
          v-model="config.details.active"
          max-height="500"
          :close-on-content-click="false"
          :activator="$refs.calendar ? $refs.calendar.$el : null">
          <v-card flat>
            <v-card-title class="grey lighten-4 blue-grey--text text--darken-4">{{ `${printTargetDate}の予定` }}</v-card-title>
            <v-card-text class="pb-0">
              <v-list dense>
                <v-list-item v-for="item in getTargetEventItems"
                  :key="item.id"
                  @click="openClientPage(item)">
                  <v-list-item-content>
                    <v-list-item-subtitle class="caption">
                      <span v-if="item.type === 'consult'">留学相談</span>
                      <span v-if="item.time">{{ `： ${item.time}〜` }}</span>
                    </v-list-item-subtitle>
                    <v-list-item-title class="body-1">{{ item.summary }}</v-list-item-title>
                    <v-list-item-subtitle class="caption">{{ item.description }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn text fab small outlined
                      color="secondary"
                      @click.stop="openUpdator(item)">
                      <v-icon small>fal fa-pencil</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item v-if="!getTargetEventItems.length">
                  <v-list-item-content>
                    <v-list-item-title class="body-1">予定なし</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn text
                color="secondary"
                @click="config.details.active = false">閉じる</v-btn>
              <v-spacer></v-spacer>
              <v-btn depressed
                color="secondary"
                @click="openEditor()"><v-icon small class="mr-2">fal fa-plus</v-icon>追加する</v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
        <v-progress-linear indeterminate :color="isLoading ? 'secondary' : 'transparent'"></v-progress-linear>
      </v-col>
      <Editor
        ref="editor"
        :fixed="config.type === 'client' && this.$props.cid"
        :cid="(config.type === 'client' && this.$props.cid) ? this.$props.cid : ''"
        :date="getTargetDate"
      />
      <Editor
        ref="updator"
        :fixed="true"
        :type="getUpdatorType"
      />
    </v-row>
  </v-card>
</template>

<script>
import _ from 'lodash'
import Editor from '@/components/calendar/modals/editor'
export default {
  name: 'sasmango-events',
  components: { Editor },
  props: [ 'cid' ],
  data () {
    return {
      socket: null,
      config: {
        type: 'all',
        status: {
          loading: false
        },
        details: {
          active: false
        },
        updator: {
          type: ''
        }
      },
      store: {
        events: [],
        consults: [],
        date: new Date().toISOString().substr(0, 10),
        targetYearMonth: '-',
        details: {
        }
      }
    }
  },
  mounted () {
    if (this.$props.cid) {
      this.$set(this.config, 'type', 'client')
    }
    this.connectSocket()
  },
  methods: {
    connectSocket: function () {
      const socket = this.$store.getters['config/get']('socket')
      if (socket && socket.connected) {
        socket.on(`EMIT_CALENDAR`, (data) => {
          const { user } = data
          this.updateEvent(data)
          if (user !== this.$store.getters['author/get']('userid')) {
            this.notifyByOthers(data)
          }
        })
      } else {
        setTimeout(() => {
          this.connectSocket()
        }, 5000)
      }
    },
    getMonthEvents: _.debounce(function (e) {
      const [ year, month ] = e ? e.split('-') : this.store.targetYearMonth.split('-')
      const belong = this.$store.getters['author/get']('belong')
      this.$set(this.config.status, 'loading', true)
      this.$firebase.auth().currentUser.getIdToken(true).then(token => {
        this.axios.post(`${this.$url.api}calendar/get/this/month`, {
          year, month,
          cid: (this.config.type === 'client' && this.$props.cid) ? this.$props.cid : '',
          belong
        }, {
          headers: {
            'firebase-token': token
          }
        }).then(res => {
          console.log(res)
          if (res.data && res.data.success) {
            const { events, consults } = res.data.data
            this.$set(this.store, 'events', events.items)
            this.$set(this.store, 'consults', consults.items)
            this.$set(this.store, 'targetYearMonth', `${year}-${month}`)
          }
          this.$set(this.config.status, 'loading', false)
        }).catch(err => {
          console.log(err)
          this.$set(this.config.status, 'loading', false)
        })
      })
    }, 1000),
    showEvents: function ({ nativeEvent, event }) {
      setTimeout(() => { this.$set(this.config.details, 'active', true) }, 10)
    },
    openEditor: function (req) {
      const { event } = req || {}
      if (!this.$refs.editor.isActive) {
        if (event) {
          this.$refs.editor.open({ type: 'update', event })
        } else {
          this.$refs.editor.open({ type: 'insert', event: req || {} })
        }
      }
    },
    openUpdator: function (req) {
      const { id, type } = req || {}
      if (type === 'consult') {
        let idx = this.store.consults.findIndex(it => { return it.id == id })
        if (idx >= 0) {
          this.$set(this.config.updator, 'type', 'consult')
          this.$nextTick(() => {
            this.$refs.updator.open({ type: 'update', event: this.store.consults[idx] })
          })
        }
      } else if (type === 'event') {
        let idx = this.store.events.findIndex(it => { return it.id == id })
        if (idx >= 0) {
          this.$set(this.config.updator, 'type', 'event')
          this.$nextTick(() => {
            this.$refs.updator.open({ type: 'update', event: this.store.events[idx]})
          })
        }
      }
    },
    openClientPage: function (req) {
      const { cid } = req || {}
      if (cid) {
         let resolve = this.$router.resolve({ path: `../client/${cid}` })
        window.open(resolve.href, '_blank')
      }
    },
    updateEvent: function (req) {
      const { calendarType, type, item } = req || { type: '', item: {} }
      if (this.store[calendarType]) {
        if (type === 'insert') {
          this.store[calendarType].push(item)
        } else if (type === 'update') {
          let idx = this.store[calendarType].findIndex(it => { return it.id === item.id })
          if (idx >= 0) {
            this.store[calendarType].splice(idx, 1, item)
          }
        } else if (type === 'remove') {
          let idx = this.store[calendarType].findIndex(it => { return it.id === item.id })
          if (idx >= 0) {
            this.store[calendarType].splice(idx, 1)
          }
        }
      }
    },
    notifyByOthers: function (req) {
      const { type, item } = req || { type: '', item: {} }
      const notifies = {
        insert: {
          title: '新しい予定',
          message: `「##TITLE##」が追加されました。`
        },
        update: {
          title: '予定の変更',
          message: `「##TITLE##」が変更されました。`
        },
        remove: {
          title: '予定の削除',
          message: `「##TITLE##」が削除されました。`
        }
      }
      const { title, message } = notifies[type] || { title: '', message: '' }
      const { summary } = item
      if (title) {
        this.$store.dispatch('notifier/addMessage', {
          title,
          message: message.replace('##TITLE##', summary)
        })
      }
    },
    functionEvents (date) {
      const [ year, month, day ] = date.split('-')
      const events = this.store.events.length ? this.store.events.filter(it => {
        return this.$moment(it.start.dateTime || it.start.date).format('YYYY-MM-DD') === date
      }) : []
      const consults = this.store.consults.length ? this.store.consults.filter(it => {
        return this.$moment(it.start.dateTime || it.start.date).format('YYYY-MM-DD') === date
      }) : []
      if (events.length && consults.length) {
        return [ 'orange', 'blue' ]
      } else if (events.length) {
        return 'orange'
      } else if (consults.length) {
        return 'blue'
      } else {
        return false
      }
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    getClientId () {
      return this.$props.cid
    },
    printTargetDate () {
      return this.store.date ? this.$moment(this.store.date).format('YYYY年MM月DD日') : ''
    },
    getTargetDate () {
      return this.store.date ? this.$moment(this.store.date).format () : ''
    },
    getTargetEventItems () {
      const events = (this.store.events && this.store.events.length) ? this.store.events.filter(it => {
        return this.$moment(it.start.dateTime || it.start.date).date() === this.$moment(this.store.date).date()
      }).map(it => {
        let privateData = it.extendedProperties && it.extendedProperties.private ? it.extendedProperties.private : {}
        return Object.assign(it, privateData, { type: 'event' })
      }) : []
      const consults = this.store.consults.length ? this.store.consults.filter(it => {
        return this.$moment(it.start.dateTime || it.start.date).date() === this.$moment(this.store.date).date()
      }).map(it => {
        let privateData = it.extendedProperties && it.extendedProperties.private ? it.extendedProperties.private : {}
        return Object.assign(it, privateData, { type: 'consult', time: it.start.dateTime ? this.$moment(it.start.dateTime).format('HH:mm') : '' })
      }) : []
      return [...events, ...consults]
    },
    getUpdatorType () {
      return this.config.updator.type
    }
  }
}
</script>